import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1cad296e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "inner"
};

const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<img class=\"logo\" src=\"https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202311/6e166038905c4987949ece691a156646.png\" alt=\"\" data-v-1cad296e><div class=\"area\" data-v-1cad296e><span class=\"area-1\" data-v-1cad296e>玄武门校区：南京市鼓楼区童家巷24号 210009</span><span data-v-1cad296e>江宁校区：南京市江宁区龙眠大道639号 211198</span></div><div class=\"line\" data-v-1cad296e></div><div class=\"case-number\" data-v-1cad296e><span data-v-1cad296e>版权所有©中国药科大学 </span><a target=\"_blank\" href=\"https://beian.miit.gov.cn/\" style=\"color:#fff;\" data-v-1cad296e>苏ICP备05007142号-1</a><span data-v-1cad296e> 苏公网安备 32011502010017号</span></div>", 4);

const _hoisted_7 = {
  key: 0,
  class: "links"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "常用链接", -1));

const _hoisted_9 = {
  class: "content"
};
const _hoisted_10 = ["href"];
const _hoisted_11 = {
  key: 0,
  class: "line"
};
export default {
  props: {
    menu: Object
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    const list = ref([]);

    const getLinkData = async () => {
      const params = {};
      const res = await $http.getFooterLink(params);
      list.value = res;
    };

    getLinkData();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, list.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.id
        }, [_createElementVNode("a", {
          href: item.target_url
        }, _toDisplayString(item.name), 9, _hoisted_10), index !== list.value.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_11)) : _createCommentVNode("", true)], 64);
      }), 128))])])) : _createCommentVNode("", true)])]);
    };
  }

};